<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbs" />
    <RentsPerUserReport />
  </Layout>
</template>

<script>
import Layout from '@/views/Layout'
import RentsPerUserReport from '@/components/Reports/Rents/RentsPerUserReport'

export default {
  name: 'ReportsRentsPerUser',
  components: {
    Layout,
    RentsPerUserReport
  },
  computed: {
    breadcrumbs: () => [
      {
        text: 'Início',
        to: { name: 'HomeIndex' }
      },
      {
        text: 'Relatórios',
        to: { name: 'ReportsIndex' }
      },
      {
        text: 'Aluguéis por Usuário',
        to: { name: 'ReportsRentsPerUser' },
        active: true
      }
    ]
  }
}
</script>
